import React from 'react';

import GameResultsTable from '../../components/Table/GameResultsTable';

const Rules = () => (
  <div className="content">
    <GameResultsTable />
  </div>
);

export default Rules;


// WEBPACK FOOTER //
// ./src/pages/GameResults/index.js